import { render, staticRenderFns } from "./SearchRateManagement.vue?vue&type=template&id=0464081e"
import script from "./SearchRateManagement.vue?vue&type=script&lang=js"
export * from "./SearchRateManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports